import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { InputWithButtonEdit } from '@/pages/_base/inputs/InputWithButtonEdit';
import { remote_workspace_user_credits_limit_update } from '@/state/workspace/user/remote_workspace_user_credits_limit_update';
import { RequestWorkspaceUserCreditsLimitUpdate } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_credits_limit_update';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { useState } from 'react';

interface Props {
  user: DTO__workspace_user;
}

export function WSTableUserCreditLimitsInput({ user }: Props) {
  const dispatch = use_dispatch();

  const [value, set_value] = useState(user.credits_limit);
  const [value_default, set_value_default] = useState(user.credits_limit);

  const [is_loading, set_is_loading] = useState(false);
  /*
   * EVENTS
   */

  async function onChangeCommited(value_string: string) {
    let value_new = value_string === '' ? 0 : Number(value_string.replace(/\D/g, ''));

    set_value(value_new);

    if (value_new === user.credits_limit) return;

    set_value_default(value_new);

    const request = new RequestWorkspaceUserCreditsLimitUpdate();

    request.target_user_id = user.user_id;
    request.workspace_id = user.workspace_id;
    request.value = value_new;

    set_is_loading(true);
    await dispatch(remote_workspace_user_credits_limit_update(request));
    set_is_loading(false);
  }

  function onChange(value_string: string) {
    const value_number = Number(value_string.replace(/\D/g, ''));

    set_value(value_number);
  }

  /*
   * METHODS
   */
  function is_disabled() {
    return is_loading || !user.credits_limit_enabled;
  }

  return (
    <InputWithButtonEdit
      disabled={is_disabled()}
      value={String(value)}
      value_default={String(value_default)}
      {...{ onChange, onChangeCommited }}
      is_format_compact_number
      className="min-h-9 max-h-9 h-9"
    />
  );
}
